/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from "react-router-dom";
import { GetManualJournalAtom, SetManualJournalAtom } from "../../store/manualJounalAtom";

import { useCallback, useContext, useEffect, useRef, useState } from "react";

import RestartAlt from '@mui/icons-material/RestartAlt';
import Tooltip from "@mui/material/Tooltip";
import Grid from '@mui/material/Grid';
import { Table, Input } from 'antd';
// import CreditNoteFilter from "./CreditNoteFilter";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { accountService } from "../../services/accountService";
import { useForm } from "react-hook-form";

import moment from "moment";
import LogicContext from "../../Context/LogicContext";
import ManualJournalType from "./ManualJournalTypeSelect";
import StatusBadge from "../../generals/StatusBadge";


const { Search } = Input;



function ManualJournalMainPage() {
  const { pathname } = useLocation();
  const setManualJournalAtom = SetManualJournalAtom();
  const getManualJournalAtom = GetManualJournalAtom();

  const navigate = useNavigate();
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const [filteredData, setFilteredData] = useState([]);
  const [selJournalTypeId, setSelJournalTypeId] = useState(0);
  const isMounted = useRef(false);
  const logicContext = useContext(LogicContext);

  const { register, getValues, formState: { errors } } = useForm();



  // Reload the page if the session storage flag is set.
  useEffect(() => {
    isMounted.current = true;
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      loadTableList();
    }
    return () => {
      isMounted.current = false;
    }
  }, []);

  // Load the list of all manual journals if it's not already in the global state.
  useEffect(() => {
    isMounted.current = true;
    document.title = 'Manual Journal ';
    if (!getManualJournalAtom.account_info?.length) {
      loadTableList();
    } else {
      setFilteredData(getManualJournalAtom.account_info);
    }
    return () => {
      isMounted.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getManualJournalAtom.account_info]);


  const reloadData = () => {
    loadTableList();
  }


  // Fetches the list of all manual journals from the server.
  const loadTableList = () => {
    accountService.manualJournal().then(res => {
      if (res.data && isMounted.current) {
        setManualJournalAtom(res.data);
        setFilteredData(res.data?.account_info);
      }
    });
  }




  function addNew() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }

  const columns = [

    {
      title: 'Acc Ref',
      key: 'account_ref_no',
      dataIndex: 'account_ref_no',
      className: "text-primary",
      sorter: (a, b) => (a?.account_ref_no ?? '') - (b?.account_ref_no ?? '')
    },
    {
      title: 'Date',
      key: 'encoded_date',
      sorter: (a, b) => a.encoded_date.localeCompare(b.encoded_date),
      dataIndex: "encoded_date",
      render: (encoded_date) => <span>{formatCustomDate(encoded_date)} </span>

    },
    {
      title: 'Journal Number',
      key: 'journal_number',
      sorter: (a, b) => (a?.journal_number ?? '') - (b?.journal_number ?? ''),
      dataIndex: "journal_number",

    },
    {
      title: 'Transaction Type',
      dataIndex: 'transation_type_name',
      sorter: (a, b) => a.transation_type_name?.toString()?.localeCompare(b?.transation_type_name?.toString())

    },
    {
      title: 'Journal Type',
      dataIndex: 'journal_type_name',
      sorter: (a, b) => a.journal_type_name?.toString()?.localeCompare(b?.journal_type_name?.toString())

    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      sorter: (a, b) => (a?.account_ref_no ?? '') - (b?.account_ref_no ?? ''),
      render: (amount) => <span> {formatCustomNumber(amount)} </span>,
    },

    {
      title: 'Status',
      dataIndex: 'status_name',
      sorter: (a, b) => a.status_name?.toString()?.localeCompare(b?.status_name?.toString()),
      render: (record, row) => (
        <StatusBadge statusId={row?.status_id ?? row?.Status_Id} statusName={record} />
      ),
    },


  ];



  // Searches for manual journals by date range.
  const searchByDate = async (event) => {
    const formData = getValues();
    const response = await accountService.getManualJournalByData({ ...formData, transaction_type_id: selJournalTypeId });
    if (response?.data?.length) {
      setFilteredData(response.data);
    } else {
      setFilteredData([]);
      logicContext.showToast(
        "No available record for your search query!",
        ""
      );
    }
  };

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: getManualJournalAtom?.account_info?.length,
    // total: filteredData.length,
    // onChange: (page, pageSize) => {
    //   const newList = tableDataList.slice(0, pageSize);
    //   setTableList(newList);
    // },
  };



  const handleRowClick = (record) => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${record?.account_ref_no}`);
  };


  const onTypeSelect = (type) => {
    setSelJournalTypeId(type?.journal_type_id);
    if (type?.journal_type_id === 0) {
      return setFilteredData(getManualJournalAtom.account_info);
    }
    const tempData = getManualJournalAtom.account_info?.filter((acc) => acc?.journal_type_name === type?.journal_type_name);
    setFilteredData(tempData);
    if (!tempData?.length) {
      return logicContext.showToast(`No available record for ${type?.journal_type_name}`, "");
    }
  }



  return (

    <>

      {/* grid start */}
      <div className="flex flex-col gap-6 p-6 bg-gray-50 rounded-lg shadow-sm z-10">
        {/* Top Controls: Reload, Date Search, Type Select, and Add New */}
        <div className="flex flex-wrap items-center justify-between gap-4">
          {/* Left Side: Reload + Date Search + Type Select */}
          <div className="flex items-center gap-4">
            {/* Reload Button */}
            <Tooltip title="Reload">
              <RestartAlt
                className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors self-center"
                onClick={() => reloadData()}
                color="primary"
                fontSize="large"
              />
            </Tooltip>

            {/* Date Range Search */}
            <div className="flex items-center gap-3">
              <div className="flex flex-col mb-3">
                <label className="text-sm font-medium text-gray-700">From Date</label>
                <input
                  defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                  {...register("from_date")}
                  type="date"
                  className="h-10 w-80  bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>
              <div className="flex flex-col mb-3">
                <label className="text-sm font-medium text-gray-700">To Date</label>
                <input
                  defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                  {...register("to_date")}
                  type="date"
                  className="h-10 w-80  bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                />
              </div>
              <ManualJournalType defaultValue={{ label: "All", journal_type_id: 0 }} list={[{ journal_type_name: "All", journal_type_id: 0 }, ...getManualJournalAtom.journal_type]}
                onTypeSelect={onTypeSelect}
                className=" h-10 w-40 bg-white border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
              />
              <button
                onClick={() => searchByDate()}
                type="button"
                className="mt-1 h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
              >
                Search
              </button>
            </div>
          </div>

          {/* Right Side: Add New Button */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => addNew()}
              className="mt-1 h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
            >
              Add New
            </button>
          </div>
        </div>

        {/* Data Count */}
        <div className="flex items-center">
          <span className="inline-flex items-center justify-center bg-blue-600 text-white text-sm font-semibold rounded-full px-4 py-2">
            {filteredData?.length} Records
          </span>
        </div>
      </div>
      {/* End */}


      <section className="mt-5   w-full">
        <div className="">


          <Table key={filteredData?.length} columns={columns}
            dataSource={filteredData?.map((item, i) => {
              return {
                ...item, Amount: formatCustomNumber(item.Amount),
                Transaction_Date: formatCustomDate(item.Transaction_Date)
              };
            })}
            pagination={paginationOptions}
            rowClassName="show-cursor"
            style={{ background: '#f0f2f5', borderRadius: '8px' }}
            onRow={(record) => {
              return {
                onClick: () => {
                  handleRowClick(record);
                },
              };
            }}
          />

        </div>
      </section>
    </>

  );
}

export default ManualJournalMainPage;
